import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
// import Role from "../config/Roles";

/** public/private routes */
import InnerContent from "./InnerContent";
import PrivateRoute from "./PrivateRoutes";
import ProtectedRoutes from "./ProtectedRoutes";
import PublicRoutes from "./PublicRoutes";

/** error page routes */
import Error403 from "../pages/ErrorPages/Error403";
import Error404 from "../pages/ErrorPages/Error404";
import Error500 from "../pages/ErrorPages/Error500";

/** authentication routes */
import Login from "../pages/Auth/Login";
import Register from "../pages/Auth/Register";

/** dashboard page route */
import Dashboard from "../pages/Dashboard/Dashboard";

/**Inventory Routes*/
/** ==> Items  */
import Items from "../pages/MainPages/Inventory/Items/Items";
import ManageItems from "../pages/MainPages/Inventory/Items/ManageItems";
import DeletedItems from "../pages/MainPages/Inventory/Items/DeletedItems";
import ItemsCustomeField from "../pages/MainPages/Inventory/Items/Itemcustomfield";
import CountInventory from "../pages/MainPages/Inventory/Items/CountInventory";
import ShowClosedCounts from "../pages/MainPages/Inventory/Items/ShowClosedCounts";
import NewInventoryCount from "../pages/MainPages/Inventory/Items/NewInventoryCount";
import ExcelImport from "../pages/MainPages/Inventory/Items/ExcelImport";
import CountInventoryBarcodeLabel from "../pages/MainPages/Inventory/Items/CountInventoryBarcodeLabel";

/**End Inventory*/

/**Customers Routes*/
import Customers from "../pages/MainPages/Contacts/Costomers/Customers";
import ManageCustomer from "../pages/MainPages/Contacts/Costomers/ManageCustomer";
import DeletedCustomers from "../pages/MainPages/Contacts/Costomers/DeletedCustomers";
import CustomerIntakeForm from "../pages/MainPages/Contacts/Costomers/CustomerIntakeForm";
import ImportExcelCustomers from "../pages/MainPages/Contacts/Costomers/ImportExcelCustomers";
import CustomerBarcodeLabel from "../pages/MainPages/Contacts/Costomers/CustomerBarcodeLabel";
import CustomFieldConfigurationCustomer from "../pages/MainPages/Contacts/Costomers/CustomFieldConfigurationCustomer";
/**End Customers */

/**Supplier Routes*/
import Suppliers from "../pages/MainPages/Suppliers/Suppliers";
import ManageSuppliers from "../pages/MainPages/Suppliers/ManageSuppliers";
import CustomFIeldConfigSuppliers from "../pages/MainPages/Suppliers/CustomFIeldConfigSuppliers";
import DeletedSuppliers from "../pages/MainPages/Suppliers/DeletedSuppliers";
import ImportExcelSupplier from "../pages/MainPages/Suppliers/ImportExcelSupplier";
import Employees from "../pages/MainPages/Employees/Employees";
import ManageEmployee from "../pages/MainPages/Employees/ManageEmployee";
import Permission from "../pages/MainPages/Employees/Permission";
/**End Supplier */

/**Receiving */
import Receiving from "../pages/MainPages/Receiving/Receiving";
import ManageReceiving from "../pages/MainPages/Receiving/ManageReceiving";

import CustomFIeldConfigReceiving from "../pages/MainPages/Receiving/CustomFieldConfigReceiving";
import SuspendedReceiving from "../pages/MainPages/Receiving/SuspendedReceiving";
import ReceivingReceipt from "../pages/MainPages/Receiving/ReceivingReceipt";
import BatchReceiving from "../pages/MainPages/Receiving/BatchReceiving";
import CreatePurchaseOrders from "../pages/MainPages/Receiving/CreatePurchaseOrder";
import RecievingBarcodeLabel from "../pages/MainPages/Receiving/RecievingBarcodeLabel";
import TransferReceiving from "../pages/MainPages/Receiving/TransferRequest";
import IncomingTransfer from "../pages/MainPages/Receiving/IncomingTransfer";
import PayBills from "../pages/MainPages/Receiving/PayBills";

/** End Receiving */

/** Sales **/
import Sales from "../pages/MainPages/Sales/Sales";
import ManageSale from "../pages/MainPages/Sales/ManageSale";
import CustomFIeldConfigSales from "../pages/MainPages/Sales/CustomeFieldConfigSales";
import SuspendedSales from "../pages/MainPages/Sales/SuspendedSales";
import SalesWorkOrders from "../pages/MainPages/Sales/SalesWorkOrders";
import CustomerFacingDisplay from "../pages/MainPages/Sales/CustomerFacingDisplay";
import BatchSale from "../pages/MainPages/Sales/BatchSale";
import SearchSale from "../pages/MainPages/Sales/SearchSale";
import ShowLastSaleReceipt from "../pages/MainPages/Sales/ShowLastSaleReceipt";
import SaleBarcodeLabel from "../pages/MainPages/Sales/SaleBarcodeLabel";
import ShowAllReceiptToday from "../pages/MainPages/Sales/ShowAllReceiptToday";

/**End Sales */

/** End GiftCard **/

import CustomFieldConfigEmployee from "../pages/MainPages/Employees/CustomFieldConfigEmployee";
import DeletedEmployees from "../pages/MainPages/Employees/DeletedEmployee";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import ResetPassword from "../pages/Auth/ResetPassword";
/**Work Orders Routes*/

import EditProfile from "../pages/Dashboard/Sidebar/editprofile";
import ItemNotCountedAndInStock from "../pages/MainPages/Inventory/Items/ItemNotCountedAndInStock";

import ItemNotCounted from "../pages/MainPages/Inventory/Items/ItemNotCounted";

//Reports
import ReportsList from "../pages/MainPages/Reports/ReportList";
import CustomerBalanceSummary from "../pages/MainPages/Reports/CustomerBalanceSummary";
import ExpenseReport from "../pages/MainPages/Reports/ExpenseReport";
import CustomerContactList from "../pages/MainPages/Reports/CustomerContactList";
import SalesbyCustomerDetail from "../pages/MainPages/Reports/SalesbyCustomerDetail";
import SalesbyCustomerTypeDetail from "../pages/MainPages/Reports/SalesbyCustomerTypeDetail";
import TransactionListByCustomer from "../pages/MainPages/Reports/TransactionListByCustomer";
import SalesbyCustomerSummaryReport from "../pages/MainPages/Reports/SalesbyCustomerSummaryReport";
import VendorBalanceSummary from "../pages/MainPages/Reports/VendorBalanceSummary";
import ExpensesbyVendorSummary from "../pages/MainPages/Reports/ExpensesbyVendorSummary";
import OpenPurchaseOrderList from "../pages/MainPages/Reports/OpenPurchaseOrderList";
import TransactionListbyVendor from "../pages/MainPages/Reports/TransactionListbyVendor";
import TransactionListbyDate from "../pages/MainPages/Reports/TransactionListbyDate";
import InvoicesandReceivedPayments from "../pages/MainPages/Reports/InvoicesandReceivedPayments";
import OpenInvoices from "../pages/MainPages/Reports/OpenInvoices";
import SalesbyProductServiceDetail from "../pages/MainPages/Reports/SalesbyProductServiceDetail";
import VendorBalanceDetail from "../pages/MainPages/Reports/VendorBalanceDetail";
import OpenPurchaseOrderDetail from "../pages/MainPages/Reports/OpenPurchaseOrderDetail";
import VendorContactList from "../pages/MainPages/Reports/VendorContactList";
import EmployeeContactList from "../pages/MainPages/Reports/EmployeeContactList";
import ProfitandLossbyCustomer from "../pages/MainPages/Reports/ProfitandLossbyCustomer";
import TrialBalance from "../pages/MainPages/Reports/TrialBalance";
import ProfitandLossDetail from "../pages/MainPages/Reports/ProfitandLossDetail";
import BalanceSheetDetail from "../pages/MainPages/Reports/BalanceSheetDetail";
import IncomebyCustomerSummary from "../pages/MainPages/Reports/IncomebyCustomerSummary";
import SalesbyProductServiceSummary from "../pages/MainPages/Reports/SalesbyProductServiceSummary";
import ProductServiceList from "../pages/MainPages/Reports/ProductServiceList";
import BillsandAppliedPayments from "../pages/MainPages/Reports/BillsandAppliedPayments";
import UnpaidBills from "../pages/MainPages/Reports/UnpaidBills";
import BalanceSheetSummary from "../pages/MainPages/Reports/BalanceSheetSummary";
import AccountsPayableAgingDetail from "../pages/MainPages/Reports/AccountsPayableAgingDetail";
import BillPaymentList from "../pages/MainPages/Reports/BillPaymentList";
import AccountsReceivableAgingDetail from "../pages/MainPages/Reports/AccountsReceivableAgingDetail";
import AccountsReceivableAgingsummary from "../pages/MainPages/Reports/AccountsReceivableAgingSummary";

// Account types

import ReceivePayment from "../pages/MainPages/Sales/ReceivePayment";
import { ToastContainer } from "react-toastify";

//Task

import ImportItems from "../pages/MainPages/Inventory/Items/ImportItems";

import CustomerBalanceDetail from "../pages/MainPages/Reports/CustomerBalanceDetail";

import PaymentLog from "../pages/MainPages/Payment Log/PaymentLog";
import { JobWork } from "../pages/MainPages/JobWork/JobWork";
import ManageJobWork from "../pages/MainPages/JobWork/ManageJobWork";
import { JobApprove } from "../pages/MainPages/JobWork/JobApprove";
import JobWorkReceipt from "../pages/MainPages/JobWork/JobWorkReceipt";
import JobWorkRequestReceipt from "../pages/MainPages/JobWork/JobWorkRequestReceipt";

// Ecomm Config

// Reports

const CustomerId = localStorage.getItem("CustomerId")
const IsCustomer = localStorage.getItem("IsCustomer")

// Start
const MainRoute = (props) => {
  return (
    <>
      <Routes>
        <Route path="/" element={<ProtectedRoutes />}>
          <Route path="/" element={<InnerContent />}>
            {/* Dashboard */}
            
            <Route path="/" element={<Navigate replace to={`/manage-customers/${CustomerId}`} />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute permission="/dashboard">
                  <Dashboard />
                </PrivateRoute>
              }
            />

            {/* Items */}
            <Route
              path="/items"
              element={
                <PrivateRoute permission="/items">
                  <Items />
                </PrivateRoute>
              }
            />
            <Route
              path="/deleted-items"
              element={
                <PrivateRoute permission="/deleted-items">
                  <DeletedItems />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-items"
              element={
                <PrivateRoute permission="/manage-items">
                  <ManageItems />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-items/:id"
              element={
                <PrivateRoute permission="/manage-items/:id">
                  <ManageItems />
                </PrivateRoute>
              }
            />
            <Route
              path="/items-custom-fields"
              element={
                <PrivateRoute permission="/items-custom-fields">
                  <ItemsCustomeField />
                </PrivateRoute>
              }
            />
            <Route
              path="/item-count-invetory"
              element={
                <PrivateRoute permission="/item-count-invetory">
                  <CountInventory />
                </PrivateRoute>
              }
            />
            <Route
              path="/new-inventory-count"
              element={
                <PrivateRoute permission="/new-inventory-count">
                  <NewInventoryCount />
                </PrivateRoute>
              }
            />
            <Route
              path="/new-inventory-count/:id"
              element={
                <PrivateRoute permission="/new-inventory-count/:id">
                  <NewInventoryCount />
                </PrivateRoute>
              }
            />
            <Route
              path="/show-closed-counts"
              element={
                <PrivateRoute permission="/show-closed-counts">
                  <ShowClosedCounts />
                </PrivateRoute>
              }
            />
            <Route
              path="/item-not-counted-and-in-stock/:id"
              element={
                <PrivateRoute permission="/item-not-counted-and-in-stock/:id">
                  <ItemNotCountedAndInStock />
                </PrivateRoute>
              }
            />
            <Route
              path="/item-not-counted/:id"
              element={
                <PrivateRoute permission="/item-not-counted/:id">
                  <ItemNotCounted />
                </PrivateRoute>
              }
            />
            <Route
              path="/item-excel-import-count/:id"
              element={
                <PrivateRoute permission="/item-excel-import-count/:id">
                  <ExcelImport />
                </PrivateRoute>
              }
            />
            <Route
              path="/import-items"
              element={
                <PrivateRoute permission="/import-items">
                  <ImportItems />
                </PrivateRoute>
              }
            />
            <Route
              path="/item-count-inventory-barcode-label/:id"
              element={
                <PrivateRoute permission="/item-count-inventory-barcode-label/:id">
                  <CountInventoryBarcodeLabel />
                </PrivateRoute>
              }
            />

            {/* Customers */}
            <Route
              path="/customers"
              element={
                <PrivateRoute permission="/customers">
                  <Customers />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-customers"
              element={
                <PrivateRoute permission="/manage-customers">
                  <ManageCustomer />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-customers/:id"
              element={
                <PrivateRoute permission="/manage-customers/:id">
                  <ManageCustomer />
                </PrivateRoute>
              }
            />

            <Route
              path="/customer-intake-form"
              element={
                <PrivateRoute permission="/customer-intake-form">
                  <CustomerIntakeForm />
                </PrivateRoute>
              }
            />

            <Route
              path="/deleted-customers"
              element={
                <PrivateRoute permission="/deleted-customers">
                  <DeletedCustomers />
                </PrivateRoute>
              }
            />

            <Route
              path="/import-excel-customers"
              element={
                <PrivateRoute permission="/import-excel-customers">
                  <ImportExcelCustomers />
                </PrivateRoute>
              }
            />

            <Route
              path="/customer-barcode-label"
              element={
                <PrivateRoute permission="/customer-barcode-label">
                  <CustomerBarcodeLabel />
                </PrivateRoute>
              }
            />

            {/* custom-field-configuration */}
            <Route
              path="/custom-field-configuration"
              element={
                <PrivateRoute permission="/custom-field-configuration">
                  <CustomFieldConfigurationCustomer />
                </PrivateRoute>
              }
            />

            {/* Supplier List */}
            <Route
              path="/suppliers"
              element={
                <PrivateRoute permission="/suppliers">
                  <Suppliers />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-suppliers"
              element={
                <PrivateRoute permission="/manage-suppliers">
                  <ManageSuppliers />
                </PrivateRoute>
              }
            />

            <Route
              path="/deleted-suppliers"
              element={
                <PrivateRoute permission="/deleted-suppliers">
                  <DeletedSuppliers />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-suppliers/:id"
              element={
                <PrivateRoute permission="/manage-suppliers/:id">
                  <ManageSuppliers />
                </PrivateRoute>
              }
            />

            <Route
              path="/import-excel-suppliers"
              element={
                <PrivateRoute permission="/import-excel-suppliers">
                  <ImportExcelSupplier />
                </PrivateRoute>
              }
            />

            {/* custom-field-configuration */}
            <Route
              path="/custom-field-Suppliers-configuration"
              element={
                <PrivateRoute permission="/custom-field-suppliers-configuration">
                  <CustomFIeldConfigSuppliers />
                </PrivateRoute>
              }
            />

            {/* Receiving */}
            <Route
              path="/receiving"
              element={
                <PrivateRoute permission="/receiving">
                  <Receiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-receiving"
              element={
                <PrivateRoute permission="/manage-receiving">
                  <ManageReceiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-receiving/:id"
              element={
                <PrivateRoute permission="/manage-receiving/:id">
                  <ManageReceiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/receiving-custom-field"
              element={
                <PrivateRoute permission="/receiving-custom-field">
                  <CustomFIeldConfigReceiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/suspended-receiving/:id"
              element={
                <PrivateRoute permission="/suspended-receiving/:id">
                  <SuspendedReceiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/receiving-receipt"
              element={
                <PrivateRoute permission="/receiving-receipt">
                  <ReceivingReceipt />
                </PrivateRoute>
              }
            />
            <Route
              path="/receiving-receipt/:id"
              element={
                <PrivateRoute permission="/receiving-receipt/:id">
                  <ReceivingReceipt />
                </PrivateRoute>
              }
            />

            <Route
              path="/batch-receiving"
              element={
                <PrivateRoute permission="/batch-receiving">
                  <BatchReceiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/transfer-request/:id"
              element={
                <PrivateRoute permission="/transfer-request/:id">
                  <TransferReceiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/incoming-transfer/:id"
              element={
                <PrivateRoute permission="/incoming-transfer/:id">
                  <IncomingTransfer />
                </PrivateRoute>
              }
            />
            <Route
              path="/create-purchase-orders"
              element={
                <PrivateRoute permission="/create-purchase-orders">
                  <CreatePurchaseOrders />
                </PrivateRoute>
              }
            />

            <Route
              path="/receiving-barcode-label"
              element={
                <PrivateRoute permiss ion="/receiving-barcode-label">
                  <RecievingBarcodeLabel />
                </PrivateRoute>
              }
            />

            <Route
              path="/receiving-barcode-label/:id"
              element={
                <PrivateRoute permiss ion="/receiving-barcode-label/:id">
                  <RecievingBarcodeLabel />
                </PrivateRoute>
              }
            />
            <Route
              path="/receiving-paybills"
              element={
                <PrivateRoute permission="/receiving-paybills">
                  <PayBills />
                </PrivateRoute>
              }
            />
            <Route
              path="/receiving-paybills/:id"
              element={
                <PrivateRoute permission="/receiving-paybills/:id">
                  <PayBills />
                </PrivateRoute>
              }
            />

            {/* Sales */}
            <Route
              path="/sales"
              element={
                <PrivateRoute permission="/sales">
                  <Sales />
                </PrivateRoute>
              }
            />

            {/* Sales */}
            <Route
              path="/manage-sales"
              element={
                <PrivateRoute permission="/manage-sales">
                  <ManageSale />
                </PrivateRoute>
              }
            />

            <Route
              path="/receive-payment"
              element={
                <PrivateRoute permission="/receive-payment">
                  <ReceivePayment />
                </PrivateRoute>
              }
            />
            <Route
              path="/receive-payment/:id"
              element={
                <PrivateRoute permission="/receive-payment/:id">
                  <ReceivePayment />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-sales/:id"
              element={
                <PrivateRoute permission="/manage-sales/:id">
                  <ManageSale />
                </PrivateRoute>
              }
            />

            <Route
              path="/custom-field-sales-configuration"
              element={
                <PrivateRoute permission="/custom-field-sales-configuration">
                  <CustomFIeldConfigSales />
                </PrivateRoute>
              }
            />

            <Route
              path="/suspended-sales"
              element={
                <PrivateRoute permission="/suspended-sales">
                  <SuspendedSales />
                </PrivateRoute>
              }
            />
            <Route
              path="/suspended-sales/:id"
              element={
                <PrivateRoute permission="/suspended-sales/:id">
                  <SuspendedSales />
                </PrivateRoute>
              }
            />

            <Route
              path="/sales-workorders"
              element={
                <PrivateRoute permission="/sales-workorders">
                  <SalesWorkOrders />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-customer-facing-display"
              element={
                <PrivateRoute permission="/sales-customer-facing-display">
                  <CustomerFacingDisplay />
                </PrivateRoute>
              }
            />

            <Route
              path="/batch-sales"
              element={
                <PrivateRoute permission="/batch-sales">
                  <BatchSale />
                </PrivateRoute>
              }
            />

            <Route
              path="/search-sales"
              element={
                <PrivateRoute permission="/search-sales">
                  <SearchSale />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-receipt"
              element={
                <PrivateRoute permission="/sales-receipt">
                  <ShowLastSaleReceipt />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-receipt/:id"
              element={
                <PrivateRoute permission="/sales-receipt/:id">
                  <ShowLastSaleReceipt />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-barcode-label"
              element={
                <PrivateRoute permission="/sales-barcode-label">
                  <SaleBarcodeLabel />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-barcode-label/:id"
              element={
                <PrivateRoute permission="/sales-barcode-label/:id">
                  <SaleBarcodeLabel />
                </PrivateRoute>
              }
            />

            <Route
              path="/sales-all-receipt"
              element={
                <PrivateRoute permission="/sales-all-receipt">
                  <ShowAllReceiptToday />
                </PrivateRoute>
              }
            />

            {/* Employees listing */}
            <Route
              path="/employees"
              element={
                <PrivateRoute permission="/employees">
                  <Employees />
                </PrivateRoute>
              }
            />

            {/*  Deleted Employees */}
            <Route
              path="/deleted-employees"
              element={
                <PrivateRoute permission="/deleted-employees">
                  <DeletedEmployees />
                </PrivateRoute>
              }
            />

            {/* Employees Upsert */}
            <Route
              path="/manage-employee"
              element={
                <PrivateRoute permission="/manage-employee">
                  <ManageEmployee />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-employee/:id"
              element={
                <PrivateRoute permission="/manage-employee/:id">
                  <ManageEmployee />
                </PrivateRoute>
              }
            />

            {/* custom-field-configuration-employee */}
            <Route
              path="/custom-field-employee-configuration"
              element={
                <PrivateRoute permission="/custom-field-employee-configuration">
                  <CustomFieldConfigEmployee />
                </PrivateRoute>
              }
            />

            {/* Permission Template */}
            <Route
              path="/manage-permissions"
              element={
                <PrivateRoute permission="/manage-permissions">
                  <Permission />
                </PrivateRoute>
              }
            />

            {/* Accounting Add Page*/}

            {/* Payment Log */}
            <Route
              path="/transaction-log"
              element={
                <PrivateRoute permission="/transaction-log">
                  <PaymentLog />
                </PrivateRoute>
              }
            />

            {/* Manage Task */}

            {/* AccountType Add Page
            {/* <Route
            path="/manage-accounttype"
            element={
              // <PrivateRoute permission="/accounting">
              <AccountTypesManage />
              // </PrivateRoute>
            }
          /> */}

            {/* AccountType Edit Page*/}
            {/* <Route
            path="/manage-accounttype/:id"
            element={
              // <PrivateRoute permission="/accounting">
              <AccountTypesManage />
              // </PrivateRoute>
            }
          /> */}

            {/* Job Works  27-10-2023*/}
            <Route
              path="/jobworks"
              element={
                <PrivateRoute permission="/jobworks">
                  <JobWork />
                </PrivateRoute>
              }
            />

            <Route
              path="/jobworks-receipt/:id"
              element={
                <PrivateRoute permission="/jobworks-receipt/:id">
                  <JobWorkReceipt />
                </PrivateRoute>
              }
            />

            <Route
              path="/jobworks-request-receipt/:id"
              element={
                <PrivateRoute permission="/jobworks-request-receipt/:id">
                  <JobWorkRequestReceipt />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-jobworks"
              element={
                <PrivateRoute permission="/manage-jobworks">
                  <ManageJobWork />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-jobworks/:id"
              element={
                <PrivateRoute permission="/manage-jobworks/:id">
                  <ManageJobWork />
                </PrivateRoute>
              }
            />

            {/* <Route
              path="/manage-jobworks/:id"
              element={
                <PrivateRoute permission="/manage-jobworks/:id">
                  <ManageJobWork />
                </PrivateRoute>
              }
            /> */}

            <Route
              path="/jobapprove"
              element={
                <PrivateRoute permission="/jobapprove">
                  <JobApprove />
                </PrivateRoute>
              }
            />

            {/* Reports */}
            <Route
              path="/reports"
              element={
                <PrivateRoute permission="/reports">
                  <ReportsList />
                </PrivateRoute>
              }
            />

            <Route
              path="/Customer-Balance-Summary"
              element={
                <PrivateRoute permission="/Customer-Balance-Summary">
                  <CustomerBalanceSummary />
                </PrivateRoute>
              }
            />
            <Route
              path="/expense-report"
              element={
                <PrivateRoute permission="/expense-report">
                  <ExpenseReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/customer-contact-list"
              element={
                <PrivateRoute permission="/customer-contact-list">
                  <CustomerContactList />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-customer-detail"
              element={
                <PrivateRoute permission="/sales-by-customer-detail">
                  <SalesbyCustomerDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-customer-type-detail"
              element={
                <PrivateRoute permission="/sales-by-customer-type-detail">
                  <SalesbyCustomerTypeDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/transaction-list-by-customer"
              element={
                <PrivateRoute permission="/transaction-list-by-customer">
                  <TransactionListByCustomer />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-customer-summary-report"
              element={
                <PrivateRoute permission="/sales-by-customer-summary-report">
                  <SalesbyCustomerSummaryReport />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/vendor-balance-summary"
              element={
                <PrivateRoute permission="/vendor-balance-summary">
                  <VendorBalanceSummary />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/expenses-by-vendor-summary"
              element={
                <PrivateRoute permission="/expenses-by-vendor-summary">
                  <ExpensesbyVendorSummary />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/open-purchase-order-list"
              element={
                <PrivateRoute permission="/open-purchase-order-list">
                  <OpenPurchaseOrderList />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/transaction-list-by-vendor"
              element={
                <PrivateRoute permission="/transaction-list-by-vendor">
                  <TransactionListbyVendor />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/transaction-list-by-date"
              element={
                <PrivateRoute permission="/transaction-list-by-vendor">
                  <TransactionListbyDate />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/invoices-and-received-payments"
              element={
                <PrivateRoute permission="/invoices-and-received-payments">
                  <InvoicesandReceivedPayments />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/customer-balance-detail"
              element={
                <PrivateRoute permission="/customer-balance-detail">
                  <CustomerBalanceDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/open-invoices"
              element={
                <PrivateRoute permission="/open-invoices">
                  <OpenInvoices />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/sales-by-product-service-detail"
              element={
                <PrivateRoute permission="/sales-by-product-service-detail">
                  <SalesbyProductServiceDetail />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/vendor-balance-detail"
              element={
                <PrivateRoute permission="/vendor-balance-detail">
                  <VendorBalanceDetail />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/open-purchase-order-detail"
              element={
                <PrivateRoute permission="/open-purchase-order-detail">
                  <OpenPurchaseOrderDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/vendor-contact-list"
              element={
                <PrivateRoute permission="/vendor-contact-list">
                  <VendorContactList />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/employee-contact-list"
              element={
                <PrivateRoute permission="/employee-contact-list">
                  <EmployeeContactList />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/profit-loss-customer"
              element={
                <PrivateRoute permission="/profit-loss-customer">
                  <ProfitandLossbyCustomer />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/trial-balance"
              element={
                <PrivateRoute permission="/trial-balance">
                  <TrialBalance />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/profit-and-loss-detail"
              element={
                <PrivateRoute permission="/profit-and-loss-detail">
                  <ProfitandLossDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/balance-sheet-detail"
              element={
                <PrivateRoute permission="/balance-sheet-detail">
                  <BalanceSheetDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/income-by-customer-summery"
              element={
                <PrivateRoute permission="/income-by-customer-summery">
                  <IncomebyCustomerSummary />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-product-service-summery"
              element={
                <PrivateRoute permission="/sales-by-product-service-summery">
                  <SalesbyProductServiceSummary />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/product-service-list"
              element={
                <PrivateRoute permission="/product-service-list">
                  <ProductServiceList />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/bills-applied-payments"
              element={
                <PrivateRoute permission="/bills-applied-payments">
                  <BillsandAppliedPayments />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/unpaid-bills"
              element={
                <PrivateRoute permission="/bills-applied-payments">
                  <UnpaidBills />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/balance-sheet-summary"
              element={
                <PrivateRoute permission="/balance-sheet-summary">
                  <BalanceSheetSummary />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/accounts-payable-aging-detail"
              element={
                <PrivateRoute permission="/accounts-payable-aging-detail">
                  <AccountsPayableAgingDetail />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/bill-payment-list"
              element={
                <PrivateRoute permission="/bill-payment-list">
                  <BillPaymentList />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/accounts-receivable-aging-detail"
              element={
                <PrivateRoute permission="/accounts-receivable-aging-detail">
                  <AccountsReceivableAgingDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/accounts-receivable-aging-summary"
              element={
                <PrivateRoute permission="/accounts-receivable-aging-summary">
                  <AccountsReceivableAgingsummary />
                </PrivateRoute>
              }
            ></Route>

            {/* My Profile */}
            <Route
              path="/edit-profile"
              element={
                <PrivateRoute permission="/edit-profile">
                  <EditProfile />
                </PrivateRoute>
              }
            />
          </Route>
        </Route>

        {/* Register */}
        <Route path="/register" element={<PublicRoutes />}>
          <Route path="/register" element={<Register />} />
        </Route>

        {/* Login */}
        <Route path="/login" element={<PublicRoutes />}>
          <Route path="/login" element={<Login />} />
        </Route>

        {/* Forgot Password */}
        <Route path="/forgetPassword" element={<PublicRoutes />}>
          <Route path="/forgetPassword" element={<ForgotPassword />} />
        </Route>

        {/* Reset Password */}
        <Route path="/resetpassword/:id" element={<PublicRoutes />}>
          <Route path="/resetpassword/:id" element={<ResetPassword />} />
        </Route>

        {/* error 404 */}
        <Route path="*" element={<Error404 />} />

        {/* error 403 */}
        <Route path="/error403" element={<Error403 />} />

        {/* error 500 */}
        <Route path="/error500" element={<Error500 />} />
      </Routes>
      <ToastContainer />
    </>
  );
};

export default MainRoute;
